var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnrichment = function SvgEnrichment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.0605469C3.61516 0.0605469 0.0605469 3.61516 0.0605469 8C0.0605469 12.3848 3.61516 15.9394 8 15.9394C12.3848 15.9394 15.9394 12.3848 15.9394 8C15.9394 3.61516 12.3848 0.0605469 8 0.0605469ZM1.26055 8C1.26055 4.2779 4.2779 1.26055 8 1.26055C11.7221 1.26055 14.7394 4.2779 14.7394 8C14.7394 11.7221 11.7221 14.7394 8 14.7394C4.2779 14.7394 1.26055 11.7221 1.26055 8ZM10.5414 11.6265V10.6575H7.12293V8.45152H10.0496V7.49707H7.12293V5.51026H10.5171V4.53633H7.12293H6.77719H5.90066V11.6265H6.77719H7.12293H10.5414Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnrichment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "enrichment.6def9d3d87f92bf2d6a7127f9613aa11.svg";